import { render } from "./IssuesSinglePage.vue?vue&type=template&id=07f7248e&scoped=true"
import script from "./IssuesSinglePage.vue?vue&type=script&lang=js"
export * from "./IssuesSinglePage.vue?vue&type=script&lang=js"

import "./IssuesSinglePage.vue?vue&type=style&index=0&id=07f7248e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f7248e"]])

export default __exports__